module.exports = __webpack_public_path__ + "media/about-teachers.75013213.mp4";